export const PERMS = {
    READ: 'report_customer_monthly_plans.read',
    EXPORT: 'report_customer_monthly_plans.export',
}
